module.exports = __webpack_public_path__ + "img/banenr_jjfa.69e495dd.png";